// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'd969fd28-f0f6-44e9-bde9-810877115227',
      type: 'Container',
      name: 'root',
      className: 'props_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        props: {
          eventMode: 'none'
        }
      },
      interactiveChildren: false
    },
    {
      id: 'd6859857-ea7d-4764-a42a-66cab03f7762',
      type: 'Sprite',
      name: 'line',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 80,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Thin_Separation',
      parent: 'd969fd28-f0f6-44e9-bde9-810877115227',
      stateByName: {
        thick: {
          texture: 'Thick_Separation'
        }
      }
    },
    {
      id: '040a0e26-981d-4922-a195-5030bd9abd3d',
      type: 'Sprite',
      name: 'lock',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Locked_Node',
      parent: 'd969fd28-f0f6-44e9-bde9-810877115227',
      stateByName: {
        lock: {
          visible: true
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'thick',
    'lock'
  ],
  handleResize: false
} as const;

export class SeasonPassSeparatorLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  line!: Sprite;
  lock!: Sprite;
  props_SPL!: (Container & { data: typeof raw['list'][0]['data'] })[];
  StateName!: 'thick' | 'lock';

  constructor() {
    populate(this, raw);
  }
}
